import { useState } from "react";
import { request } from "utils/request";

export const usePropertyAutoFill = () => {
  const [autoFillLoading, setAutoFillLoading] = useState(false);

  const fetchPropertyDetails = async (
    formData,
    isManual = false,
    setToastMessage,
    setToastVariant,
    setShowToast,
    onInputChange
  ) => {
    // Check if we have enough address info to make the API call
    if (!formData.address1 || !formData.city || !formData.state) {
      if (isManual) {
        setToastMessage(
          "Please fill in Address1, City, and State before using Auto-Fill"
        );
        setToastVariant("error");
        setShowToast(true);
      }
      return;
    }

    try {
      if (isManual) {
        setAutoFillLoading(true);
      }

      // Construct the address string
      const address = `${formData.address1}, ${formData.city}, ${formData.state}`;

      const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";

      const data = await request(
        `${baseUrl}/reports/zillow-property/?address=${encodeURIComponent(address)}`,
        { method: "GET" }
      );

      // Apply the response to form fields (always overwrite)
      onInputChange("house_type", data.house_type || "");
      onInputChange("year_build", data.year_build || "");
      onInputChange("floor_area", data.floor_area || "");
      onInputChange("stories", data.stories || "");
      onInputChange("apn", data.apn || "");

      // Show success toast based on mode
      if (isManual) {
        setToastMessage("Property details filled successfully");
        setToastVariant("success");
        setShowToast(true);
      } else {
        setToastMessage("Property details auto-filled");
        setToastVariant("success");
        setShowToast(true);
      }
    } catch (error) {
      console.error("Auto-fill failed:", error);
      // Only show error toast for manual mode
      if (isManual) {
        setToastMessage(
          "Property details not found for this address. Please check address or fill manually."
        );
        setToastVariant("error");
        setShowToast(true);
      }
    } finally {
      if (isManual) {
        setAutoFillLoading(false);
      }
    }
  };

  const handleManualAutoFill = (
    formData,
    setToastMessage,
    setToastVariant,
    setShowToast,
    onInputChange
  ) => {
    fetchPropertyDetails(
      formData,
      true,
      setToastMessage,
      setToastVariant,
      setShowToast,
      onInputChange
    );
  };

  const handleAutoAutoFill = (
    formData,
    setToastMessage,
    setToastVariant,
    setShowToast,
    onInputChange
  ) => {
    // Check if property details are all empty
    const hasPropertyDetails =
      formData.year_build ||
      formData.floor_area ||
      formData.stories ||
      formData.house_type ||
      formData.apn;

    if (!hasPropertyDetails) {
      fetchPropertyDetails(
        formData,
        false,
        setToastMessage,
        setToastVariant,
        setShowToast,
        onInputChange
      );
    }
  };

  return {
    autoFillLoading,
    handleManualAutoFill,
    handleAutoAutoFill,
  };
};
